import {useState} from 'react'

export function useMotivoError() {
  const [error, setError] = useState<string | null>(null)
  return {error, setError, clear: () => setError(null)}
}
